'use client';
import AppLayout from '@/components/AppLayout';
import NotificationsCenterContent from './components/NotificationsCenterContent';
import { useAuth } from '@/contexts/AuthContext';

export default function NotificationsPage() {
  const { getUserProfile } = useAuth();
  return (
    <AppLayout>
      <NotificationsCenterContent />
    </AppLayout>
  );
}
